import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { deleteFeedback } from "@/redux/slices/feedbackSlice";
import { toast } from "react-toastify";
const Delete = ({ showModal, setShowModal, feedbackId }) => {
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(deleteFeedback(feedbackId));
    toast.info(`Xóa phản hồi thành công`);
    setShowModal(false);
  };
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      size="sm"
    >
      <Modal.Body className="text-center">
        <Form onSubmit={handleSubmit}>
          <h5 className="mb-3">Xóa đánh giá</h5>
          <p className="mb-3">Bạn có chắc chắn muốn xóa đánh giá này không?</p>
          <div className="d-flex align-items-center justify-content-center">
            <Button
              variant="light"
              className="me-2"
              onClick={() => setShowModal(false)}
            >
              Không
            </Button>
            <Button type="submit" variant="primary">
              Có
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default Delete;
